import './index.scss'

let type = '₴';
let filter = document.querySelector('.shop_filter_price__block');
let min = +filter.dataset.min_price;
let max = +filter.dataset.max_price;
let min_user = +filter.dataset.user_min_price;
let max_user = +filter.dataset.user_max_price;
const filterSlider = document.querySelector('.filter__slider')
let elem_min = document.querySelectorAll('.shop_filter_price_min')[0];
let elem_max = document.querySelectorAll('.shop_filter_price_max')[0];
const inputs = document.querySelectorAll('.filter__input')

console.log('min', min);
console.log('max', max);
console.log('min_user', min_user);
console.log('max_user', max_user);


noUiSlider.create(filterSlider, {
    start: [min_user, max_user],
    connect: true,
    step: 1,
    range: {
        'min': Math.round(min),
        'max': Math.round(max)
    }
})



filterSlider.noUiSlider.on('update', (val, handl) => {
    inputs[handl].value = Math.round(val[handl])
})

const setValueSlider = (i, val) => {
    let arr = []
    arr[i] = val
    filterSlider.noUiSlider.set(arr)
}

inputs.forEach((el, i) => {
    el.addEventListener('change', (e) => {
        setValueSlider(i, e.currentTarget.value)
    })
})

if (document.querySelector('.filter__btn-show')) {
    document.querySelector('.filter__btn-show').addEventListener('click', () => {
        document.querySelector('.filter__btn-show').classList.toggle('active')
        document.querySelector('.filter').classList.toggle('filter_mob')
        document.querySelector('.nav_items').classList.remove('mobile')
        document.querySelector('.nav_hor_mobile').classList.remove('active')
        document.querySelector('.header').classList.remove('active')
        document.querySelector('.dot_container').classList.remove('active')
    })
}

document.querySelector('.filter__close').addEventListener('click', () => {
    document.querySelector('.filter').classList.remove('filter_mob')
})


document.querySelectorAll('.sort_bottom_sections > a').forEach(item => {
    item.addEventListener('click', (e) => {
        e.target.classList.add('shop_sort_link_active')
    })
})

let select = document.querySelector('.sort_select').options
if (document.querySelector('.shop_sort_arrow_active')) {
    select.selectedIndex = document.querySelector('.shop_sort_arrow_active').index
}

document.querySelector('.sort_select').addEventListener('change', () => {
    let data = `prioritet=${select[select.selectedIndex].dataset.href}` 
    filter_data([false, false, data])
})


let price_btn = document.querySelectorAll('.filter_set_btn');

if (price_btn.length >= 1) {
    price_btn.forEach(element => {
        let object_values;
        let data = element.dataset.href;
        let check_page = element.classList.contains('shop_pagination_page');
        let check_sort = element.classList.contains('shop_sort_link');
        let check_prioritet = element.classList.contains('shop_sort_arrow');
        if (check_page) {
            object_values = [data, false, false];
        } else if (check_sort) {
            data = `sub_category=${data}`
            object_values = [false, data, false];
        } 
        else if (check_prioritet) {
            data = `prioritet=${data}`
            object_values = [false, false, data];
        } 
        else {
            object_values = [false, false, false];
        }
        element.addEventListener('click', function () {
            filter_data(object_values);
        });
    });
}


let params = window
    .location
    .search
    .replace('?', '')
    .split('&')
    .reduce(
        function (p, e) {
            var a = e.split('=');
            p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            return p;
        },
        {}
    );

updateFilter(params['page_number'], 'page_number', 'shop_pagination_page_active');
updateFilter(params['sub_category'], 'sub_category', 'shop_sort_link_active');
updateFilter(params['prioritet'], 'prioritet', 'shop_sort_arrow_active');

function updateFilter(param, name, activeClass) {
    let hrefAttr = `[data-href='${name}=${param}']`;
    let activeItem = document.querySelector(`.${activeClass}`);
    let currentItem = document.querySelector(hrefAttr);
    if (currentItem != null) {
        activeItem.classList.remove(activeClass);
        currentItem.classList.add(activeClass);
    }
}


const filter_data = ([page, sort_cart, prioritet]) => {
    let array_url = [];
    let current_url;
    let shop_pagination__block = document.querySelector('.shop_pagination__block');
    let shop_filter = document.querySelectorAll('.shop_filter');
    if (shop_pagination__block != undefined) {
        let page_number = page ? page : 'page_number=1';
        array_url.push(page_number);
    }
    if (document.querySelector('.shop_sort_arrow_active')) {
        let sort_arrow = prioritet ? prioritet : `prioritet=${document.querySelector('.shop_sort_arrow_active').dataset.href}`;
        array_url.push(sort_arrow);
    }
    if (document.querySelector('.shop_sort_link_active')) {
        let sort = sort_cart ? sort_cart : `sub_category=${document.querySelector('.shop_sort_link_active').dataset.href}`;
        array_url.push(sort);
    }

    shop_filter.forEach(block => {
        let type = block.dataset.type;
        let type_options = [];
        let item = `${type}=`;
        if (type == 'price') {
            let min = document.querySelector('.shop_filter_price_min').value;
            let max = document.querySelector('.shop_filter_price_max').value;
            // data[type] = [min, max];
            item += `${min},${max}`;
        } 
        else if (type == 'means') {
            let options = block.querySelectorAll('.checked');
            options.forEach(element => {
                let name = element.dataset.means;
                type_options.push(name);
            });
            item += type_options.join(',');
        }
        else {
            let options = block.querySelectorAll('.checked');
            options.forEach(element => {
                let name = element.dataset.code;
                type_options.push(name);
            });
            item += type_options.join(',');
        }
        array_url.push(item);

    });

    current_url = array_url.join('&');
    window.location = `?${current_url}`;
}

const all_checkbox_options = document.querySelectorAll('.checkbox_option');

all_checkbox_options.forEach(option => {
    option.addEventListener("change", function (e) {
        if (e.target.checked) {
            option.classList.add('checked');
        } else {
            option.classList.remove('checked');
        }
    })
});

document.querySelector('.filter__reset').addEventListener('click', () => {
    all_checkbox_options.forEach(option => {
        option.classList.remove('checked');
        if (document.querySelector('.shop_sort_link_active')) {
            document.querySelector('.shop_sort_link_active').classList.remove('shop_sort_link_active')
        }
        if (document.querySelector('.shop_sort_arrow_active')) {
            document.querySelector('.shop_sort_arrow_active').classList.remove('shop_sort_arrow_active')
        }

        document.querySelector('.shop_filter_price_min').value = ''
        document.querySelector('.shop_filter_price_max').value = ''
        filter_data([false, false, false]);
    })
})
